import { useTenantCustomizations } from "src/tenantCustomizations/TenantCustomizationsContext.ts";
import { AsyncMenuButton } from "src/components/common/contextMenu/AsyncMenuButton.tsx";
import { faFileImport } from "@fortawesome/pro-regular-svg-icons";
import { useInputDialog } from "src/components/common/dialogs/input/useInputDialog.tsx";
import i18n from "i18next";
import { uploadFile } from "src/utils/fileUploading.ts";
import { CustomerOfferLineTabularImportApi } from "src/api/generated/erp/sales/customerOrderOffer/api/customerOfferLineTabularImportApi.ts";

export interface ImportCustomerOfferLinesFromTabularDataButtonProps {
	customerOfferId: number;
	afterImport?: () => Promise<unknown>;
}

export const ImportCustomerOfferLinesFromTabularDataButton = ({
	customerOfferId,
	afterImport,
}: ImportCustomerOfferLinesFromTabularDataButtonProps) => {
	const { tenantConfig } = useTenantCustomizations();
	const showInputDialog = useInputDialog();
	if (!tenantConfig.erp.customerOfferLineImportMethods.includes("STANDARD_TABULAR")) return null;

	return (
		<AsyncMenuButton
			label={i18n.t("import_customer_offer_lines")}
			icon={faFileImport}
			onClick={async () => {
				const file = await showInputDialog({
					type: "singleFile",
					title: i18n.t("select_a_file"),
					defaultValue: null,
					required: true,
				});
				if (file === undefined) return;

				const fileHandle = await uploadFile(file);

				await CustomerOfferLineTabularImportApi.importLines({
					customerOfferId: customerOfferId,
					fileHandle: fileHandle,
				});
				await afterImport?.();
			}}
		/>
	);
};
